/**
 * These are MLS Mapper event data keys. They identify the data in the posted message.
 * @see IMlsMapperMessage
 */
export enum MlsMapperEventKeys {
    none = '', // the initialization method uses this & should be changed
    addresses = 'mlsm-addresses',
    importLimit = 'mlsm-import-limit'
}
